/**
 * Site Name Configuration
 * Auto-generated from: KEYWORD + NICHE + COUNTRY
 * Format: {keyword} {niche} {country}
 * This file is auto-generated - do not edit manually
 * 
 * Generated at: 2026-03-30T14:19:07.933Z
 */

// Site name auto-generated from keyword, niche, and country
export const SITE_NAME = 'meet latina united states'

export default SITE_NAME
